import { 
  Footprints,
  Flame,
  Route,
  Timer,
  Heart,
  Activity,
  Moon,
  Zap,
} from "lucide-react";
import { MetricConfig } from "./types";

export const defaultMetrics: MetricConfig[] = [
  {
    id: 'steps',
    icon: Footprints,
    label: 'Steps',
    value: (data) => data.steps,
    unit: '',
    category: 'strain',
    order: 0
  },
  {
    id: 'calories',
    icon: Flame,
    label: 'Calories',
    value: (data) => data.calories,
    unit: 'cal',
    category: 'strain',
    order: 1
  },
  {
    id: 'distance',
    icon: Route,
    label: 'Distance',
    value: (data) => data.distance,
    unit: 'km',
    category: 'strain',
    order: 2
  },
  {
    id: 'activeMinutes',
    icon: Timer,
    label: 'Active Minutes',
    value: (data) => data.activeMinutes,
    unit: 'mins',
    category: 'strain',
    order: 3
  },
  {
    id: 'heartRate',
    icon: Heart,
    label: 'Heart Rate',
    value: (data) => data.heartRate,
    unit: 'bpm',
    category: 'strain',
    order: 4
  },
  {
    id: 'bloodOxygen',
    icon: Activity,
    label: 'Blood Oxygen',
    value: (data) => data.bloodOxygen,
    unit: '%',
    category: 'sleep',
    order: 5
  },
  {
    id: 'sleepScore',
    icon: Moon,
    label: 'Sleep Score',
    value: (data) => data.sleepScore,
    unit: '/100',
    category: 'sleep',
    order: 6
  },
  {
    id: 'readinessScore',
    icon: Zap,
    label: 'Readiness Score',
    value: (data) => data.readinessScore,
    unit: '/100',
    category: 'recovery',
    order: 7
  }
];